import {
  TransportAdminBase,
  TransportAdminCreatePayload,
  TransportAdminFormValues,
  TransportAdminUpdatePayload,
} from './type'

export function mapAPIDataToFormValues(data: TransportAdminBase): TransportAdminFormValues {
  return {
    id: data.transport_id,
    userId: data.user_id,
    name: data.name,
    mobile: data.mobile,
    countryCode: data.country_code,
    status: data.transport_status,
  }
}

export function mapFormDataToCreatePayload(
  data: TransportAdminFormValues
): TransportAdminCreatePayload {
  return {
    name: data.name,
    mobile: data.mobile.replace('+' + data.countryCode, ''),
    country_code: data.countryCode,
    user_status: data.status,
  }
}

export function mapFormDataToUpdatePayload(
  data: TransportAdminFormValues
): TransportAdminUpdatePayload {
  return {
    name: data.name,
    mobile: data.mobile.replace('+' + data.countryCode, ''),
    country_code: data.countryCode,
    user_status: data.status,
    user_id: data.userId!,
    transport_id: data.id!,
  }
}
